import { createFileRoute } from '@tanstack/react-router'

import { MasterLayout } from '@/widgets/master-layout'

export const Route = createFileRoute('/_master-layout')({
    component: MasterLayout,
    onEnter: () => {
        document.title = 'Катит | Панель мастера'
    },
})
